import { SaveOutlined } from '@ant-design/icons';
import { Modal, Row, Switch } from 'antd';
import { Button } from 'components/Button/Button';
import { VFC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Modal as messages } from './messages';

interface SendModalProps {
  isVisible: boolean;
  isSendingData: boolean;
  memoizeValues?: boolean;
  onMemoizeChange?: (value: boolean) => void;
  onCancel: () => void;
  onSaveRecord: () => void;
  onHandleSubmit: () => void;
}

export const SendDataModal: VFC<SendModalProps> = ({
  isVisible,
  isSendingData,
  memoizeValues,
  onMemoizeChange,
  onCancel,
  onSaveRecord,
  onHandleSubmit,
}) => {
  return (
    <Modal
      maskClosable
      confirmLoading={isSendingData}
      footer={
        <Row wrap={false}>
          <Button icon={<SaveOutlined />} loading={isSendingData} onClick={onSaveRecord}>
            <FormattedMessage {...messages.save} />
          </Button>
          <Button key="submit" loading={isSendingData} type="primary" onClick={onHandleSubmit}>
            {isSendingData ? <FormattedMessage {...messages.sending} /> : <FormattedMessage {...messages.send} />}
          </Button>
        </Row>
      }
      open={isVisible}
      onCancel={onCancel}
    >
      <FormattedMessage {...messages.sendOptions} />
      {onMemoizeChange && (
        <>
          <br />
          <Switch
            checkedChildren={<FormattedMessage {...messages.rememberValues} />}
            defaultChecked={memoizeValues}
            unCheckedChildren={<FormattedMessage {...messages.doNotRememberValues} />}
            onChange={onMemoizeChange}
          />
        </>
      )}
    </Modal>
  );
};
